import styled from 'styled-components';

import colours from 'theme/atoms/colours';
import * as Text from 'theme/components/Text.style';

export const Container = styled.div`
  align-items: center;
  display: flex;
  gap: 5px;
`;

export const ArrowButton = styled.button`
  align-items: center;
  appearance: none;
  background: none;
  border: none;
  color: ${colours.neutral[900]};
  cursor: pointer;
  display: inline-flex;
  flex-shrink: 0;
  height: 40px;
  justify-content: center;
  margin: 0;
  padding: 0;
  width: 40px;

  &:hover:not(:disabled) {
    color: ${colours.neutral[700]};
  }

  &:disabled {
    color: ${colours.neutral[400]};
    cursor: not-allowed;
  }

  &:focus-visible {
    outline: 2px solid ${colours.neutral[400]};
    outline-offset: 2px;
    border-radius: 8px;
  }

  svg {
    height: 24px;
    width: 24px;
  }

  svg path {
    stroke: currentColor;
  }
`;

export const Title = styled(Text.H4)`
  padding: 0;
`;
